import { format, utcToZonedTime, zonedTimeToUtc } from 'date-fns-tz';
import { parseISO } from 'date-fns';

export const toUserTimezone = (utcDate, timezone) => {
  if (!utcDate) return null;
  const date = typeof utcDate === 'string' ? parseISO(utcDate) : utcDate;
  return utcToZonedTime(date, timezone);
};

// Функция для преобразования старого формата в новый
const convertDateFormat = (dateFormat) => {
  if (!dateFormat) return 'dd/MM/yyyy';
  return dateFormat
    .replace(/DD/g, 'dd')
    .replace(/YYYY/g, 'yyyy')
    .replace(/YY/g, 'yy');
};

export const formatDateOnly = (utcDate, timezone, dateFormat = 'dd/MM/yyyy') => {
  if (!utcDate) return 'N/A';
  const zoned = toUserTimezone(utcDate, timezone);
  const isLegacyFormat = dateFormat.includes('DD') || dateFormat.includes('YYYY');
  return format(zoned, dateFormat, {
    useAdditionalDayOfYearTokens: isLegacyFormat,
    useAdditionalWeekYearTokens: isLegacyFormat,
  });
};

export const formatTimeOnly = (utcDate, timezone, timeFormat = '24h') => {
  if (!utcDate) return 'N/A';
  const zoned = toUserTimezone(utcDate, timezone);
  const formatStr = timeFormat === '12h' ? 'hh:mm a' : 'HH:mm';
  return format(zoned, formatStr);
};

export const formatDateTime = (utcDate, timezone, dateFormat = 'dd/MM/yyyy', timeFormat = '24h') => {
  if (!utcDate) return 'N/A';
  const datePart = formatDateOnly(utcDate, timezone, dateFormat);
  const timePart = formatTimeOnly(utcDate, timezone, timeFormat);
  return `${datePart} ${timePart}`;
};





// Convert user's local date to UTC for storage
export const toUTC = (localDate, timezone) => {
  if (!localDate) return null;
  return zonedTimeToUtc(localDate, timezone);
};

// Format date according to user preferences
export const formatDate = (utcDate, timezone, formatStr = 'dd/MM/yyyy', timeFormat = '24h') => {
  if (!utcDate) return 'N/A';
  const zonedDate = toUserTimezone(utcDate, timezone);
  const timeFormatStr = timeFormat === '24h' ? 'HH:mm' : 'hh:mm a';
  return format(zonedDate, `${formatStr} ${timeFormatStr}`);
};


// Get relative time (e.g., "2 hours ago")
export const getRelativeTime = (utcDate, timezone) => {
  if (!utcDate) return 'N/A';
  const zonedDate = toUserTimezone(utcDate, timezone);
  const now = new Date();
  const diff = now - zonedDate;
  
  const minutes = Math.floor(diff / 60000);
  const hours = Math.floor(diff / 3600000);
  const days = Math.floor(diff / 86400000);
  
  if (minutes < 1) return 'Just now';
  if (minutes < 60) return `${minutes} minute${minutes > 1 ? 's' : ''} ago`;
  if (hours < 24) return `${hours} hour${hours > 1 ? 's' : ''} ago`;
  if (days < 7) return `${days} day${days > 1 ? 's' : ''} ago`;
  
  return formatDateOnly(utcDate, timezone);
};

// Get user's timezone list
export const getTimezones = () => {
  return Intl.supportedValuesOf('timeZone').map(tz => ({
    value: tz,
    label: tz.replace(/_/g, ' ')
  }));
};

// Convert work order times for display
export const formatWorkOrderTimes = (workOrder, userTimezone, dateFormat, timeFormat) => {
  return {
    startTime: formatDate(workOrder.startTime, userTimezone, dateFormat, timeFormat),
    endTime: formatDate(workOrder.endTime, userTimezone, dateFormat, timeFormat),
    createdAt: formatDate(workOrder.createdAt, userTimezone, dateFormat, timeFormat),
    completedAt: workOrder.completedAt ? formatDate(workOrder.completedAt, userTimezone, dateFormat, timeFormat) : null,
  };
};
